import { memo, useId, type SVGProps } from "react";

import { withUniqueSvgIds } from "./withUniqueSvgIds";

const SvgLuggage = (props: SVGProps<SVGSVGElement>) => {
  const idPrefix = useId().replace(/:/g, "");

  return withUniqueSvgIds(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 72 72"
      aria-hidden="true"
      {...props}
    >
      <g filter="url(#luggage_svg__a)" opacity={0.5}>
        <ellipse cx={36} cy={66.09} fill="#000" rx={17.6} ry={0.69} />
      </g>
      <path
        fill="url(#luggage_svg__b)"
        d="M24.75 66.09a2.81 2.81 0 1 0 0-5.63 2.81 2.81 0 0 0 0 5.63"
      />
      <path
        fill="url(#luggage_svg__c)"
        d="M47.25 66.09a2.81 2.81 0 1 0 0-5.63 2.81 2.81 0 0 0 0 5.63"
      />
      <path
        fill="url(#luggage_svg__d)"
        d="M47.25 60.46a2.8 2.8 0 0 1 2.81 2.82h-5.63a2.8 2.8 0 0 1 2.82-2.82"
      />
      <path
        fill="url(#luggage_svg__e)"
        d="M24.75 60.46a2.8 2.8 0 0 1 2.81 2.82h-5.62a2.8 2.8 0 0 1 2.8-2.82"
      />
      <path
        fill="url(#luggage_svg__f)"
        d="M40.22 8.03h-8.44v19.61a1.4 1.4 0 1 1-2.8 0V8.03a2.9 2.9 0 0 1 2.8-2.97h8.44a2.9 2.9 0 0 1 2.81 2.97v19.61a1.4 1.4 0 0 1-2.8 0z"
      />
      <foreignObject width={34.63} height={39.93} x={18.68} y={24.06}>
        <div
          style={{
            backdropFilter: "blur(.5px)",
            clipPath: "url(#luggage_svg__g)",
            height: "100%",
            width: "100%",
          }}
        />
      </foreignObject>
      <path
        fill="url(#luggage_svg__h)"
        d="M48.09 25.06H23.9a4.2 4.2 0 0 0-4.22 4.22v29.5a4.2 4.2 0 0 0 4.22 4.21h24.19a4.2 4.2 0 0 0 4.22-4.22V29.28a4.2 4.2 0 0 0-4.22-4.22"
      />
      <path
        fill="#ff4524"
        d="M31.43 31.94a.7.7 0 0 0-.7.7v25.02a.7.7 0 0 0 1.4 0V32.64a.7.7 0 0 0-.7-.7m4.58 0a.7.7 0 0 0-.7.7v25.02a.7.7 0 0 0 1.4 0V32.64a.7.7 0 0 0-.7-.7m4.56 0a.7.7 0 0 0-.7.7v25.02a.7.7 0 0 0 1.4 0V32.64a.7.7 0 0 0-.7-.7"
        opacity={0.3}
      />
      <path
        fill="url(#luggage_svg__i)"
        d="M36.39 42.73s-.39-1.16-.79-1.52l-1.7-4.53 1.73-.65s.4-.36.74-.48.7-.06.7-.06l2.83-1.06.66-.46.68-.05 1.74-.88.25.05c.13.43.67 1.99.67 1.99l1.65 4.37-1.13.61-.6.34-.84.2-1.7.73s-.34-.1-.72.06c-.37.15-.7.48-.7.48l-2.8 1.05c-.28-.1-.67-.2-.67-.2"
      />
      <path
        fill="#275bff"
        d="M43.02 7.87H28.96a2.8 2.8 0 0 1 2.81-2.81h8.44a2.8 2.8 0 0 1 2.81 2.8"
        opacity={0.4}
      />
      <defs>
        <linearGradient
          id="luggage_svg__d"
          x1={47.25}
          x2={47.25}
          y1={61.88}
          y2={63.08}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#141414" />
          <stop offset={1} stopColor="#141414" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="luggage_svg__e"
          x1={24.75}
          x2={24.75}
          y1={61.88}
          y2={63.08}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#141414" />
          <stop offset={1} stopColor="#141414" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="luggage_svg__f"
          x1={24.5}
          x2={38.54}
          y1={17.05}
          y2={17.05}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#dca6ff" stopOpacity={0.9} />
          <stop offset={1} stopColor="#daa6ff" stopOpacity={0.9} />
        </linearGradient>
        <linearGradient
          id="luggage_svg__h"
          x1={36}
          x2={36}
          y1={25.06}
          y2={64.21}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fcdb1f" stopOpacity={0.5} />
          <stop offset={1} stopColor="#fe9012" />
        </linearGradient>
        <linearGradient
          id="luggage_svg__i"
          x1={33.9}
          x2={47.19}
          y1={37.83}
          y2={37.83}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.1} stopColor="#fff" />
          <stop offset={0.12} stopColor="#e3e3e3" />
          <stop offset={0.2} stopColor="#fff" />
          <stop offset={0.21} stopColor="#e3e3e3" />
          <stop offset={0.23} stopColor="#e3e3e3" />
          <stop offset={0.45} stopColor="#fff" stopOpacity={0.97} />
          <stop offset={0.46} stopColor="#e3e3e3" />
          <stop offset={0.55} stopColor="#fff" />
          <stop offset={0.56} stopColor="#e3e3e3" />
          <stop offset={1} stopColor="#e3e3e3" />
        </linearGradient>
        <radialGradient
          id="luggage_svg__b"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="translate(24.75 63.27)scale(2.8125)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.33} stopColor="#1f1f1f" />
          <stop offset={0.46} stopColor="#4d4d4d" />
          <stop offset={0.76} stopColor="#4d4d4d" />
          <stop offset={0.83} stopColor="#3b3b3b" />
          <stop offset={1} stopColor="#141414" />
        </radialGradient>
        <radialGradient
          id="luggage_svg__c"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="translate(47.25 63.27)scale(2.8125)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.33} stopColor="#1f1f1f" />
          <stop offset={0.46} stopColor="#4d4d4d" />
          <stop offset={0.76} stopColor="#4d4d4d" />
          <stop offset={0.83} stopColor="#3b3b3b" />
          <stop offset={1} stopColor="#141414" />
        </radialGradient>
        <clipPath id="luggage_svg__g" transform="translate(-18.68 -24.06)">
          <path d="M48.09 25.06H23.9a4.2 4.2 0 0 0-4.22 4.22v29.5a4.2 4.2 0 0 0 4.22 4.21h24.19a4.2 4.2 0 0 0 4.22-4.22V29.28a4.2 4.2 0 0 0-4.22-4.22" />
        </clipPath>
        <filter
          id="luggage_svg__a"
          width={39.2}
          height={5.4}
          x={16.4}
          y={63.4}
          filterUnits="userSpaceOnUse"
        >
          <feGaussianBlur stdDeviation={1} />
        </filter>
      </defs>
    </svg>,
    idPrefix,
  );
};

const Memo = memo(SvgLuggage);
export default Memo;
